import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../../../../shared/search/search.service';
import { ResourceService } from 'sce-core';
import { environment } from '../../../../../../environments/environment';
import { SearchCriteria } from '../../../../../shared/search/models/search-filter-model';

@Component({
  selector: 'lfwms-pallet-image-popup',
  templateUrl: './pallet-image-popup.component.html',
  styleUrls: ['./pallet-image-popup.component.css']
})
export class PalletImagePopupComponent implements OnInit {

  public palletId: string;
  public receiptKey: string;
  private baseURL: string;
  public searchCriteria: any;
  public searchService: SearchService;
  public carouselImages: string[] = [];

  constructor(private resourceService: ResourceService) {
    this.baseURL = environment.wmsApiBaseUrl + 'file/';
  }

  public ngOnInit() {
    this.searchCriteria = new SearchCriteria();
    this.searchService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: 'receiptKey',
          operation: '=',
          value: this.receiptKey,
          logicalOperation: null
        }, {
          column: 'palletId',
          operation: '=',
          value: this.palletId,
          logicalOperation: null
        }],
        logicalOperation: null
      }]
    });
    this.searchService.performSearch();
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/asrs/pallet-image-home/pallet-image-popup/pallet-image-popup.component.ts